export interface JsonFormControl {
    name: string;
    label?: string;
    type: FieldType;
    options?: {};
    optionType?: string;
    required?: boolean;
    validators?: JsonFormValidators;
    group?: JsonFormControl[];
}
export enum FieldType {
    Group = 'group',
    Array = 'array',
    Text = 'text',
    Toggle = 'toggle',
    Date = 'date',
    Number = 'number',
    Multiselect = 'multiselect',
    Map = 'map'
}

export interface JsonFormData {
    data?: JsonFormControl[];
}

export interface JsonFormValidators {
    required?: boolean;
    number?: boolean;
}
